<template>
  <layout-register :step="step" :title-step="$t('m128')">
    <form @submit="getPaymentData">
      <div class="container-fluid p0">
        <div class="row">
          <div class="col-md-12 col-xs-12 col-sm-12 col-12">
            <p class="subtitle">
              {{ $t('m124') }}
            </p>
            <label class="form-label">{{ $t('m125') }}</label>
            <a-select
              class="awto-select"
              :options="options"
              label="appPaymentDescription"
              :clearable="false"
              :searchable="false"
              :selectable="item => !item.disabled"
              v-model="paymentMethod"
            >
              <template
                v-slot:option="{
                  appPaymentDescription,
                  appPaymentImg,
                  disabled,
                }"
              >
                <div style="display: flex; align-items: center">
                  <img
                    v-if="!disabled"
                    class="icon-select"
                    :src="appPaymentImg"
                  />
                  {{ appPaymentDescription }}
                </div>
              </template>
              <template
                #selected-option="{ appPaymentDescription, appPaymentImg }"
              >
                <div style="display: flex; align-items: center">
                  <img
                    class="icon-select"
                    style="margin-right: 8px"
                    :src="appPaymentImg"
                  />
                  {{ appPaymentDescription }}
                </div>
              </template>
            </a-select>
            <span
              class="text-modal-activator payment-modal-activator"
              @click="showModal = true"
              >{{ $t('m105') }}</span
            >
          </div>
          <div class="col-md-12 col-xs-12 col-sm-12 col-12">
            <h2 class="i-have-a-code">{{ $t('m106') }}</h2>
            <p class="put-your-code">
              {{ $t('m107') }}
            </p>
          </div>
          <div class="col-md-6 col-xs-12 col-sm-12 col-12">
            <div class="code-input-container">
              <input
                ref="referralInput"
                type="text"
                v-model="referral"
                :placeholder="$t('m108')"
              />
              <button
                @click.prevent="validateReferralCode"
                ref="referralButton"
              >
                {{ $t('m109') }}
              </button>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-7 col-xs-12 col-sm-12 col-12">
            <a-btn
              class="next-step-button"
              primary
              type="submit"
              :loading="loadingBtn"
            >
              {{ $t('m127') }}
            </a-btn>
          </div>
          <form ref="oneclick" method="post" :action="url">
            <input type="hidden" name="TBK_TOKEN" :value="token" />
          </form>
        </div>
      </div>
    </form>
    <a-modal class="modal-md" v-if="showModal" @close="showModal = false">
      <h2 slot="header">
        {{ $t('m105') }}
      </h2>
      <div slot="body">
        <p>
          {{ $t('m111', { awto: $store.getters['visualResources/appName'] }) }}
        </p>
        <h3>
          {{ $t('m112') }}
        </h3>
        <p class="bold">
          {{ $t('m113') }}
        </p>
        <p>
          {{ $t('m114') }}
        </p>
        <p class="bold">
          {{ $t('m115') }}
        </p>
        <p v-html="$t('m116')"></p>
        <h3>
          {{ $t('m117') }}
        </h3>
        <p class="bold">
          {{ $t('m118') }}
        </p>
        <p v-html="$t('m119')"></p>
        <!-- <p class="bold">
          {{ $t('m115') }}
        </p> -->
        <p v-html="$t('m126')"></p>
      </div>
      <div slot="footer"></div>
    </a-modal>
  </layout-register>
</template>

<script>
import ASelect from 'vue-select';
import AModal from '@/components/ui/AModal';
import ALink from '@/components/ui/ALink';
import ABtn from '@/components/ui/ABtn';

import 'vue-select/dist/vue-select.css';

export default {
  name: 'Payment',
  components: {
    ASelect,
    AModal,
    // eslint-disable-next-line vue/no-unused-components
    ALink,
    ABtn,
  },
  data() {
    return {
      step: 9,
      titlePage: this.$t('m174'),
      nextBtnText: this.$t('m175'),
      membershipType: 'frecuente',
      showModal: false,
      paymentMethod: {},
      options: [],
      paymentList: [],
      loadingBtn: false,
      url: '',
      token: '',
      referral: '',
    };
  },
  methods: {
    getPaymentData(e) {
      e.preventDefault();
      this.loadingBtn = true;
      this.$store
        .dispatch('register/getPaymentData', this.paymentMethod.paymentId)
        .then(response => {
          console.log('Payment method:', { ...this.paymentMethod });
          switch (this.paymentMethod.paymentId) {
            case 4:
              this.$router.push({ name: 'KUSHKI' });
              break;
            case 1:
              this.goToOneClick(response.url, response.token);
              break;
            case 3:
            case 6:
              this.$store
                .dispatch(
                  'register/setRegistrationStep',
                  response.registrationStep,
                )
                .then(() => {
                  this.$router.push({ name: response.registrationStep });
                });
              break;
            default:
              if (typeof response.url === 'string') {
                window.location.href = `${window.location.origin}${response.url}`;
              }
              break;
          }
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
    goToOneClick(url, token) {
      this.url = url;
      this.token = token;
      if (this.token) {
        setTimeout(() => {
          this.$refs.oneclick.submit();
        }, 500);
      } else {
        this.$toast.error(
          'Ha ocurrido un error en el servidor, intente nuevamente',
        );
      }
    },
    validateReferralCode() {
      if (this.referral) {
        this.loadingBtn = true;
        this.$store
          .dispatch('register/referral', { referralCode: this.referral })
          .then(() => {
            this.$toast.success('El código fue canjeado correctamente');
            this.$refs.referralButton.disabled = true;
            this.$refs.referralInput.disabled = true;
          })
          .catch(() => {
            this.referral = '';
          })
          .finally(() => {
            this.loadingBtn = false;
          });
      } else {
        this.$toast.info('No se ha ingresado ningún código');
      }
    },
  },
  mounted() {
    this.$store.dispatch('register/getPaymentList').then(paymentList => {
      this.paymentList = paymentList;
      let prepaidList = [];
      let postpaidList = [];
      this.paymentList.forEach(payment => {
        if (payment.paymentType === 0) {
          prepaidList.push(payment);
        } else {
          postpaidList.push(payment);
        }
      });
      this.options.push({
        disabled: true,
        appPaymentDescription: 'Postpago',
        appPaymentImg: '',
      });
      this.options.push(...postpaidList);
      this.options.push({
        disabled: true,
        appPaymentDescription: 'Prepago',
        appPaymentImg: '',
      });
      this.options.push(...prepaidList);
      this.paymentMethod = this.options[1];
    });
  },
};
</script>

<style lang="sass">
.icon-select
  max-height: 20px
  margin-right: 8px
</style>
